/**
 * HTTPエラーコードとメッセージキーのマッピング定義
 *
 * API から error.response.data.code を取得し、
 * 対応するメッセージキーを返すためのマッピング
 */

/** 409エラーコードとメッセージキーのマッピング */
export const HTTP_409_ERROR_CODE_MAPPING: Record<string, string> = {
  /** 削除時のコンフリクトエラー */
  HTTP_409_CONFLICT_DELETE: 'message.http_409.can_not_delete',
  HTTP_409_CONFLICT_UPDATE: 'message.http_409.can_not_update',
  HTTP_409_CONFLICT_NOTIFY: 'message.http_409.can_not_notify',
} as const

/**
 * HTTPステータスコード別のエラーコードマッピング
 */
export const ERROR_CODE_MAPPING = {
  409: HTTP_409_ERROR_CODE_MAPPING,
} as const

/**
 * エラーコードからメッセージキーを取得する関数
 *
 * @param statusCode HTTPステータスコード
 * @param errorCode APIから返されるエラーコード
 * @returns 対応するメッセージキー、見つからない場合はundefined
 */
export const getErrorMessageKey = (
  statusCode: number,
  errorCode: string,
): string | undefined => {
  const mapping =
    ERROR_CODE_MAPPING[statusCode as keyof typeof ERROR_CODE_MAPPING]
  return mapping?.[errorCode]
}
